<h4 mat-dialog-title>Modification propriétés</h4>
<mat-divider></mat-divider>
<form (ngSubmit)="onSubmit()" [formGroup]="editTextAreaForm">
    <mat-dialog-content class="mat__typography">
        <div fxLayout="column" fxLayoutGap="15px">
            <div>
                <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                    <mat-label>{{placeholderTitle}}</mat-label>
                    <input formControlName="placeholder" matInput
                           matTooltip="{{placeholderText}}"
                           placeholder="{{placeholderText}}"
                           type="text">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                    <mat-label>{{tooltipTitle}}</mat-label>
                    <input formControlName="tooltip" matInput
                           matTooltip="{{tooltipText}}"
                           placeholder="{{tooltipText}}"
                           type="text">
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button (click)="onNoClick()"
                mat-raised-button
                color="primary"
                type="button">
            Annuler
        </button>
        <button mat-raised-button
                cdkFocusInitial
                color="accent"
                type="submit">
            Sauvegarder
        </button>
    </mat-dialog-actions>
</form>

